exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".add-edit-integral .title-info{padding:20px;border-bottom:1px solid #d6d6d6}.add-edit-integral .title-info h3{font-weight:700;font-size:15px;border-left:4px solid #e65454;padding-left:10px}.add-edit-integral .edit-content{margin-top:20px;margin-left:100px}.add-edit-integral .edit-content .line-info{margin-bottom:20px}.add-edit-integral .edit-content .line-info .left{display:inline-block;width:120px;margin-right:10px;text-align:right}.add-edit-integral .edit-content .line-info .left .required{color:#e65454}.add-edit-integral .edit-content .line-info .right{display:inline-block}.add-edit-integral .edit-content .line-info .right .input-box-stage{width:450px}.add-edit-integral .edit-content .btn-style{margin-left:260px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/user/integral-event/add-edit-integral/add-edit-integral.scss
// module id = 556
// module chunks = 2